import { Check } from "lucide-react";

const SLUG = "outsourced-financial-management";

/**
 * What we can take care of, grouped the way a finance function is actually
 * divided: the daily processing, the management layer above it, and what goes
 * out to the people who rely on the numbers.
 *
 * Grouped rather than one long tick list, because the grouping is the point -
 * it shows the service covers all three levels, not just the bottom one.
 */
export const ScopeGroups = ({ groups }) => (
  <section data-testid={`${SLUG}-scope`} className="py-14 sm:py-20">
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <h2 className="max-w-[34ch] text-[27px] font-bold leading-[1.15] tracking-[-0.015em] text-foreground sm:text-[34px]">
        What we can take care of
      </h2>
      <p className="mt-4 max-w-[62ch] text-[15px] leading-relaxed text-muted-foreground sm:text-base">
        Take on all three layers, or only the parts your business is missing.
      </p>

      <div className="mt-9 grid grid-cols-1 gap-5 lg:grid-cols-3">
        {groups.map(({ title, caption, icon: Icon, items, anchorId }) => (
          <article
            key={title}
            /* Ads sitelinks point at a single card, so the card carries the id
               and its own clearance from the sticky header. */
            id={anchorId}
            data-testid={`${SLUG}-scope-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="tt-card flex scroll-mt-24 flex-col p-6"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[color:var(--tt-accent)]/10 text-[color:var(--tt-accent)]">
              <Icon className="h-5 w-5" aria-hidden="true" />
            </span>
            <h3 className="mt-4 text-[13px] font-bold uppercase tracking-[0.1em] text-foreground">
              {title}
            </h3>
            <p className="mt-2 text-[13px] leading-relaxed text-muted-foreground">{caption}</p>

            <ul className="mt-5 space-y-2.5 border-t border-border pt-5">
              {items.map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-[13.5px] text-foreground">
                  <Check
                    className="mt-[3px] h-3.5 w-3.5 shrink-0 text-[color:var(--tt-accent)]"
                    aria-hidden="true"
                  />
                  <span className="leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </div>
  </section>
);
